export default {
  LOAD_STUDY_PROGRAM_OVERVIEW_PAGE_START: 'LoadStudyProgramOverviewPageStart',
  LOAD_STUDY_PROGRAM_OVERVIEW_PAGE_END: 'LoadStudyProgramOverviewPageEnd',
  SELECT_STUDY_PROGRAM_OVERVIEW_PAGE_TAB: 'SelectStudyProgramOverviewPageTab'
};